document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.getElementById('MobileNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.hidden = expanded;
    });
  }
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });
  document.querySelectorAll('[data-product-thumb]').forEach(function (button) {
    button.addEventListener('click', function () {
      const mainImage = document.querySelector('.product-main-image');
      if (mainImage) mainImage.src = button.getAttribute('data-product-thumb');
    });
  });
});